// @ts-ignore
import { CommonModule } from '@angular/common';
// @ts-ignore
import { Component } from '@angular/core';
// @ts-ignore
import { FormsModule } from '@angular/forms';

interface ManualSubTela {
  titulo: string;
  descricao: string;
  ativo?: boolean;
  manual?: 'demonstrativo' | 'impressao' | 'comissoes';
}

interface ManualTela {
  titulo: string;
  descricao: string;
  subtelas: ManualSubTela[];
}

interface ManualFuncao {
  titulo: string;
  descricao: string;
  tipoImagem: string;
  comoUsar: string[];
}

@Component({
  selector: 'app-gpl-manual',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './gpl-manual.component.html',
  styleUrl: './gpl-manual.component.css'
})
export class GplManualComponent {
  filtroIndice = '';
  modalComoUsar: ManualFuncao | null = null;
  manualSelecionado: 'demonstrativo' | 'impressao' | 'comissoes' = 'demonstrativo';
  tourDemonstrativoIndice: number | null = null;

  telas: ManualTela[] = [
    {
      titulo: 'Inicio',
      descricao: 'Acesso principal do sistema.',
      subtelas: [
        { titulo: 'Home', descricao: 'Manual pendente.' }
      ]
    },
    {
      titulo: 'Vendas',
      descricao: 'Lancamento e consulta de vendas.',
      subtelas: [
        { titulo: 'Pedido de Venda', descricao: 'Manual pendente.' }
      ]
    },
    {
      titulo: 'Relatorios',
      descricao: 'Consultas, impressao e relatorios gerenciais.',
      subtelas: [
        { titulo: 'Demonstrativo de Vendas', descricao: 'Manual disponivel.', ativo: true, manual: 'demonstrativo' },
        { titulo: 'Impressao de Venda', descricao: 'Manual disponivel.', ativo: true, manual: 'impressao' },
        { titulo: 'Relatorios de Comissoes', descricao: 'Manual disponivel.', ativo: true, manual: 'comissoes' }
      ]
    },
    {
      titulo: 'Produtos',
      descricao: 'Cadastro, edicao, cotacao e movimentacoes.',
      subtelas: [
        { titulo: 'Cadastrar', descricao: 'Manual pendente.' },
        { titulo: 'Edicao/Cotacao', descricao: 'Manual pendente.' },
        { titulo: 'Transferencia de Local', descricao: 'Manual pendente.' }
      ]
    },
    {
      titulo: 'Parametrizacao',
      descricao: 'Regras e controles administrativos.',
      subtelas: [
        { titulo: 'Regras de Comissao', descricao: 'Manual pendente.' },
        { titulo: 'Motivos de Cancelamento', descricao: 'Manual pendente.' },
        { titulo: 'Controle de Acessos', descricao: 'Manual pendente.' }
      ]
    },
    {
      titulo: 'Ajuda',
      descricao: 'Documentacao e orientacoes do sistema.',
      subtelas: [
        { titulo: 'Manual GPL', descricao: 'Indice de telas e manuais disponiveis.' }
      ]
    }
  ];

  funcoesDemonstrativo: ManualFuncao[] = [
    {
      titulo: 'Cliente / Vendedor',
      descricao: 'Define se a consulta sera feita por cliente ou por vendedor. Ao alternar, a tela limpa a selecao atual para evitar misturar resultados.',
      tipoImagem: 'tipo-busca',
      comoUsar: [
        'Para definir se o demonstrativo ira listar vendas por cliente ou por vendedor, use as opcoes Cliente e Vendedor no inicio dos filtros.',
        'Selecione Cliente quando quiser consultar as vendas vinculadas a um cliente especifico.',
        'Selecione Vendedor quando quiser consultar as vendas vinculadas a um vendedor especifico.',
        'Ao trocar entre Cliente e Vendedor, a tela limpa a selecao atual para evitar que resultados de buscas diferentes sejam misturados.'
      ]
    },
    {
      titulo: 'Busca principal',
      descricao: 'Localiza o cliente ou vendedor por nome, codigo ou documento. Depois da selecao, a busca usa as datas informadas para carregar o demonstrativo.',
      tipoImagem: 'busca-principal',
      comoUsar: [
        'Digite parte do nome, documento ou codigo no campo de busca principal.',
        'Aguarde a lista de resultados aparecer e clique no cliente ou vendedor desejado.',
        'Depois da selecao, confira o periodo informado nos campos Data Inicial e Data Final.',
        'Clique em Buscar para carregar o demonstrativo com a selecao e o periodo atuais.'
      ]
    },
    {
      titulo: 'Data inicial e Data final',
      descricao: 'Limitam o periodo das vendas exibidas. Ajuste as datas e clique em Buscar para recarregar os dados.',
      tipoImagem: 'datas',
      comoUsar: [
        'Use Data Inicial para indicar o primeiro dia do periodo que deve ser consultado.',
        'Use Data Final para indicar o ultimo dia do periodo.',
        'As vendas exibidas na tabela serao limitadas ao intervalo informado.',
        'Depois de alterar qualquer uma das datas, clique em Buscar para refazer a consulta.'
      ]
    },
    {
      titulo: 'Buscar',
      descricao: 'Executa a consulta com cliente ou vendedor selecionado, periodo e filtros atuais.',
      tipoImagem: 'buscar',
      comoUsar: [
        'Depois de selecionar Cliente ou Vendedor e definir o periodo, clique em Buscar.',
        'O sistema envia os filtros atuais para carregar as vendas correspondentes.',
        'Se nenhum registro for encontrado, a tela exibe um aviso informando que nao ha dados para o periodo.',
        'Se existirem vendas, o demonstrativo e os totais serao atualizados.'
      ]
    },
    {
      titulo: 'WhatsApp',
      descricao: 'Permite informar o numero e enviar o demonstrativo ou dados da venda pelo fluxo de WhatsApp configurado.',
      tipoImagem: 'whatsapp',
      comoUsar: [
        'Informe o numero de WhatsApp no campo correspondente.',
        'Clique no botao WhatsApp para iniciar o envio pelo fluxo configurado.',
        'Antes de enviar, confira se o demonstrativo exibido pertence ao cliente, vendedor e periodo corretos.',
        'Use esta funcao quando precisar compartilhar rapidamente as informacoes exibidas na tela.'
      ]
    },
    {
      titulo: 'Salvar PDF',
      descricao: 'Gera o PDF do demonstrativo conforme a visualizacao atual da tela.',
      tipoImagem: 'pdf',
      comoUsar: [
        'Clique em Salvar PDF para gerar um arquivo com o demonstrativo atual.',
        'O PDF considera os dados carregados, filtros aplicados e visualizacao atual.',
        'Use esta opcao quando precisar arquivar ou enviar o demonstrativo fora do sistema.',
        'Antes de salvar, confira cliente ou vendedor, periodo e totais.'
      ]
    },
    {
      titulo: 'Imprimir',
      descricao: 'Abre a impressao do demonstrativo. Use as opcoes da tela para definir o comportamento de impressao.',
      tipoImagem: 'imprimir',
      comoUsar: [
        'Clique em Imprimir para abrir a impressao do demonstrativo.',
        'Confira a pre-visualizacao do navegador antes de confirmar.',
        'Use as opcoes disponiveis na tela para ajustar o comportamento de impressao, quando houver.',
        'A impressao deve ser usada depois que os dados e filtros estiverem revisados.'
      ]
    },
    {
      titulo: 'Acoes selecionadas',
      descricao: 'Menu usado para alterar cotacao, forma de pagamento, cliente, prefixo, QR-Code Pix, finalizar vendas e outras operacoes em vendas marcadas.',
      tipoImagem: 'acoes',
      comoUsar: [
        'Primeiro marque uma ou mais vendas na tabela usando os checkboxes.',
        'Abra o menu de acoes para visualizar as operacoes disponiveis.',
        'Escolha a acao desejada, como alterar forma de pagamento, alterar cliente, alterar prefixo ou finalizar vendas.',
        'Quando um modal de confirmacao for exibido, revise as vendas selecionadas antes de confirmar.'
      ]
    },
    {
      titulo: 'Valor Pix / Alterar QR-Code Pix',
      descricao: 'Permite informar um valor manual para gerar novos QR-Codes Pix no demonstrativo.',
      tipoImagem: 'pix',
      comoUsar: [
        'Digite o valor desejado no campo Valor Pix.',
        'Clique em Alterar Valor do QR-Code Pix para atualizar os QR-Codes exibidos no demonstrativo.',
        'Use esta funcao quando o valor do QR-Code precisar ser diferente do total calculado automaticamente.',
        'Apos aplicar, confira os QR-Codes e os valores antes de imprimir ou salvar PDF.'
      ]
    },
    {
      titulo: 'Filtros de Prefixo, Empresa e Codigo',
      descricao: 'Refinam a visualizacao sem sair da tela, restringindo as vendas exibidas no demonstrativo.',
      tipoImagem: 'filtros',
      comoUsar: [
        'Use Filtrar Prefixos para exibir apenas vendas relacionadas a determinados prefixos.',
        'Use Filtrar Empresa para restringir a lista por empresa.',
        'Use Filtrar Vendas ou Codigo para localizar vendas especificas dentro do demonstrativo.',
        'Os filtros refinam a visualizacao atual sem trocar o cliente ou vendedor selecionado.'
      ]
    },
    {
      titulo: 'Moeda',
      descricao: 'Alterna a exibicao entre valores em dolar e valores em real, mantendo os totais coerentes com a opcao marcada.',
      tipoImagem: 'moeda',
      comoUsar: [
        'Clique em US Dolar para visualizar os valores convertidos em dolar.',
        'Clique em R$ Real para visualizar os valores em reais.',
        'A opcao marcada define como os valores principais serao apresentados no demonstrativo.',
        'Sempre confira a moeda selecionada antes de salvar PDF, imprimir ou enviar o demonstrativo.'
      ]
    },
    {
      titulo: 'Status / Limpar',
      descricao: 'Filtra vendas por status e permite limpar filtros para retornar a uma visualizacao mais ampla.',
      tipoImagem: 'status',
      comoUsar: [
        'Use o filtro de Status para visualizar apenas vendas em uma situacao especifica.',
        'Clique em Limpar para remover filtros aplicados e retornar a uma visualizacao mais ampla.',
        'Se a lista parecer incompleta, verifique se algum status ou filtro esta ativo.',
        'Depois de limpar, aplique novamente apenas os filtros necessarios.'
      ]
    },
    {
      titulo: 'Zoom',
      descricao: 'Botoes de mais, menos e alternancia rapida ajustam o tamanho do demonstrativo para conferencia, impressao ou PDF.',
      tipoImagem: 'zoom',
      comoUsar: [
        'Use o botao de mais para aumentar o zoom do demonstrativo.',
        'Use o botao de menos para reduzir o zoom.',
        'Use o botao de alternancia para trocar rapidamente entre o zoom padrao e o zoom maximo.',
        'Ajuste o zoom para facilitar conferencia visual, impressao ou geracao de PDF.'
      ]
    },
    {
      titulo: 'Tabela de vendas',
      descricao: 'Lista as vendas do periodo. Use os checkboxes para selecionar vendas antes de executar acoes em lote.',
      tipoImagem: 'tabela',
      comoUsar: [
        'A tabela lista as vendas encontradas para o cliente ou vendedor no periodo informado.',
        'Use os checkboxes para selecionar uma ou mais vendas.',
        'As vendas selecionadas serao usadas pelas acoes em lote, como finalizar vendas ou alterar forma de pagamento.',
        'Antes de executar qualquer acao, confira numero, status, valores e demais informacoes da venda.'
      ]
    }
  ];

  funcoesImpressaoVenda: ManualFuncao[] = [
    {
      titulo: 'Buscar cliente',
      descricao: 'Localiza o cliente por nome, codigo ou documento para listar as vendas disponiveis para impressao.',
      tipoImagem: 'imp-busca-cliente',
      comoUsar: [
        'Digite parte do nome, documento ou codigo do cliente no campo de busca.',
        'Aguarde a lista de resultados e selecione o cliente correto.',
        'A tela mantem a busca e os resultados ao voltar de uma venda selecionada.',
        'Depois de selecionar o cliente, confira a lista de vendas exibida abaixo.'
      ]
    },
    {
      titulo: 'Periodo da busca',
      descricao: 'Filtra as vendas listadas pela data inicial e data final informadas.',
      tipoImagem: 'imp-datas',
      comoUsar: [
        'Use Data inicial para informar o primeiro dia que deve ser considerado.',
        'Use Data final para informar o ultimo dia do periodo.',
        'Clique em Buscar para recarregar as vendas do cliente usando o periodo atual.',
        'Se a lista parecer incompleta, revise as datas antes de selecionar a venda.'
      ]
    },
    {
      titulo: 'Selecionar venda',
      descricao: 'Abre o orcamento de venda correspondente, com cliente, entrega, itens, totais e dados para pagamento.',
      tipoImagem: 'imp-lista-vendas',
      comoUsar: [
        'Depois que as vendas forem carregadas, localize a venda desejada na lista.',
        'Confira numero unico, venda, data, status, prefixo, COM e valores.',
        'Clique na linha da venda para abrir a impressao do orcamento.',
        'A tela de impressao sera exibida mantendo a origem para o botao Voltar funcionar corretamente.'
      ]
    },
    {
      titulo: 'Voltar',
      descricao: 'Retorna para a origem correta: demonstrativo ou busca interna da propria Impressao de Venda.',
      tipoImagem: 'imp-voltar',
      comoUsar: [
        'Use Voltar quando precisar sair do orcamento aberto.',
        'Se a venda veio do Demonstrativo de Vendas, o sistema retorna para o demonstrativo restaurando o estado.',
        'Se a venda veio da busca da Impressao de Venda, o sistema retorna para a busca com cliente e resultados mantidos.',
        'O botao fica fora da area impressa e nao aparece no papel ou PDF.'
      ]
    },
    {
      titulo: 'Zoom',
      descricao: 'Ajusta a visualizacao do orcamento para conferencia, impressao e geracao de PDF.',
      tipoImagem: 'imp-zoom',
      comoUsar: [
        'Use o botao de mais para aumentar o zoom da pagina A4.',
        'Use o botao de menos para reduzir o zoom.',
        'Use a lupa de alternancia para trocar entre o zoom padrao e o zoom maximo.',
        'Ajuste o zoom apenas para conferencia visual; a impressao e o PDF preservam o layout da pagina.'
      ]
    },
    {
      titulo: 'Imprimir',
      descricao: 'Abre a impressao do orcamento de venda, com opcao de preto e branco quando marcada na tela.',
      tipoImagem: 'imp-imprimir',
      comoUsar: [
        'Confira o orcamento completo antes de imprimir.',
        'Marque a opcao de preto e branco somente quando quiser que a impressao saia sem cores.',
        'Clique em Imprimir e revise a pre-visualizacao do navegador.',
        'A area de controles da tela nao e enviada para impressao.'
      ]
    },
    {
      titulo: 'Gerar PDF',
      descricao: 'Gera um PDF colorido do orcamento exatamente com a estrutura visual da tela.',
      tipoImagem: 'imp-pdf',
      comoUsar: [
        'Clique em Gerar PDF depois de conferir os dados da venda.',
        'O PDF deve preservar fundos, tabelas, cores e disposicao dos blocos.',
        'Quando houver mais de uma pagina, todos os blocos devem ser incluidos.',
        'Use esta opcao para salvar ou enviar o orcamento ao cliente.'
      ]
    },
    {
      titulo: 'Lista de pecas / produtos',
      descricao: 'Exibe itens, serial, IPI, valores e totais, mantendo continuidade quando houver quebra de pagina.',
      tipoImagem: 'imp-itens',
      comoUsar: [
        'Confira Part Number, descricao, quantidade, valor unitario e total de cada item.',
        'Quando houver serial, ele aparece alinhado ao item correspondente.',
        'O IPI de cada produto aparece dentro da area do item, abaixo do valor em reais.',
        'Se a lista passar de uma pagina, o cabecalho da lista deve ser recriado na pagina seguinte.'
      ]
    },
    {
      titulo: 'Dados para pagamento',
      descricao: 'Rodape do orcamento com QR-Codes e dados bancarios, mantido sempre junto na impressao.',
      tipoImagem: 'imp-pagamento',
      comoUsar: [
        'Revise os dados bancarios e QR-Codes antes de enviar o orcamento.',
        'Na impressao, este bloco deve sair sempre inteiro.',
        'Se nao houver espaco suficiente no fim da pagina, ele sera levado para a pagina seguinte.',
        'Use esta area para orientar o cliente sobre as formas de pagamento disponiveis.'
      ]
    }
  ];

  funcoesRelatoriosComissoes: ManualFuncao[] = [
    {
      titulo: 'Periodo do relatorio',
      descricao: 'Define o intervalo de datas usado para consultar as comissoes exibidas na tela.',
      tipoImagem: 'com-periodo',
      comoUsar: [
        'Informe a data inicial e a data final do periodo que deve ser analisado.',
        'Use periodos menores quando precisar conferir uma venda, vendedor ou fechamento especifico.',
        'Depois de alterar as datas, execute novamente a busca para atualizar os valores.',
        'Sempre confira o periodo antes de exportar ou usar os totais para conferencia.'
      ]
    },
    {
      titulo: 'Buscar',
      descricao: 'Executa a consulta das comissoes usando o periodo e os filtros atuais.',
      tipoImagem: 'com-buscar',
      comoUsar: [
        'Depois de definir o periodo e os filtros desejados, clique em Buscar.',
        'A tela recarrega os dados de comissao conforme os parametros informados.',
        'Se nenhum dado aparecer, revise o periodo e os filtros aplicados.',
        'Use Buscar sempre que alterar filtros para garantir que a listagem esteja atualizada.'
      ]
    },
    {
      titulo: 'Filtros',
      descricao: 'Permitem refinar a listagem por vendedor, empresa, status, produto ou demais criterios disponiveis na tela.',
      tipoImagem: 'com-filtros',
      comoUsar: [
        'Use os filtros para reduzir a lista e localizar as comissoes que deseja conferir.',
        'Combine filtros quando precisar analisar um vendedor, empresa ou situacao especifica.',
        'Ao limpar ou alterar filtros, clique em Buscar novamente.',
        'Se o resultado parecer incompleto, verifique se existe algum filtro ativo restringindo a tela.'
      ]
    },
    {
      titulo: 'Resumo de valores',
      descricao: 'Apresenta totais consolidados para facilitar a conferencia geral do relatorio.',
      tipoImagem: 'com-resumo',
      comoUsar: [
        'Confira os cards ou campos de resumo depois de carregar a consulta.',
        'Use esses totais para validar rapidamente o volume de comissoes do periodo.',
        'Quando aplicar filtros, os valores de resumo devem acompanhar a listagem filtrada.',
        'Antes de tomar decisao de pagamento, compare o resumo com os detalhes da tabela.'
      ]
    },
    {
      titulo: 'Tabela analitica',
      descricao: 'Lista os lancamentos de comissao com os dados necessarios para conferencia linha a linha.',
      tipoImagem: 'com-tabela',
      comoUsar: [
        'Use a tabela para conferir os registros individualmente.',
        'Verifique vendedor, venda, cliente, produto, base de calculo, percentual e valor da comissao.',
        'Quando houver ordenacao por coluna, use-a para agrupar visualmente informacoes semelhantes.',
        'A tabela e o ponto principal para validar divergencias antes de exportar ou finalizar uma conferencia.'
      ]
    },
    {
      titulo: 'Agrupamentos',
      descricao: 'Organiza as informacoes por vendedor, regra, produto ou outro criterio disponivel, facilitando a leitura do relatorio.',
      tipoImagem: 'com-agrupamento',
      comoUsar: [
        'Use agrupamentos quando precisar analisar totais por vendedor ou categoria.',
        'Abra ou recolha grupos para navegar com mais facilidade em relatorios longos.',
        'Compare os subtotais dos grupos com o resumo geral da tela.',
        'Quando estiver procurando uma divergencia, comece pelo grupo e depois detalhe as linhas internas.'
      ]
    },
    {
      titulo: 'Exportar ou imprimir',
      descricao: 'Gera uma saida do relatorio para conferencia externa, arquivo ou compartilhamento.',
      tipoImagem: 'com-exportar',
      comoUsar: [
        'Depois de revisar periodo, filtros e totais, use a opcao de exportacao ou impressao disponivel.',
        'Confira se a listagem exibida e exatamente a que deve ser enviada ou arquivada.',
        'Evite exportar antes de aplicar filtros finais, para nao gerar arquivo com dados excessivos.',
        'Use a saida gerada como apoio, mantendo a tela como referencia principal de conferencia.'
      ]
    }
  ];

  telasFiltradas(): ManualTela[] {
    const termo = this.filtroIndice.trim().toUpperCase();
    if (!termo) return this.telas;

    return this.telas
      .map((tela) => ({
        ...tela,
        subtelas: tela.subtelas.filter((subtela) =>
          `${tela.titulo} ${tela.descricao} ${subtela.titulo} ${subtela.descricao}`.toUpperCase().includes(termo)
        )
      }))
      .filter((tela) => tela.subtelas.length > 0 || `${tela.titulo} ${tela.descricao}`.toUpperCase().includes(termo));
  }

  abrirComoUsar(funcao: ManualFuncao): void {
    this.modalComoUsar = funcao;
  }

  iniciarTourDemonstrativo(): void {
    this.manualSelecionado = 'demonstrativo';
    this.modalComoUsar = null;
    this.tourDemonstrativoIndice = 0;
  }

  fecharTourDemonstrativo(): void {
    this.tourDemonstrativoIndice = null;
  }

  proximoTourDemonstrativo(): void {
    if (this.tourDemonstrativoIndice === null) return;
    const proximo = this.tourDemonstrativoIndice + 1;
    this.tourDemonstrativoIndice = proximo >= this.funcoesDemonstrativo.length ? null : proximo;
  }

  anteriorTourDemonstrativo(): void {
    if (this.tourDemonstrativoIndice === null || this.tourDemonstrativoIndice === 0) return;
    this.tourDemonstrativoIndice -= 1;
  }

  funcaoTourDemonstrativo(): ManualFuncao | null {
    if (this.tourDemonstrativoIndice === null) return null;
    return this.funcoesDemonstrativo[this.tourDemonstrativoIndice] || null;
  }

  classeTourDemonstrativo(): string {
    const funcao = this.funcaoTourDemonstrativo();
    return funcao ? `tour-${funcao.tipoImagem}` : '';
  }

  progressoTourDemonstrativo(): string {
    if (this.tourDemonstrativoIndice === null) return '';
    return `${this.tourDemonstrativoIndice + 1} / ${this.funcoesDemonstrativo.length}`;
  }

  selecionarSubtela(subtela: ManualSubTela): void {
    if (!subtela.manual) return;
    this.manualSelecionado = subtela.manual;
  }

  subtelaAtiva(subtela: ManualSubTela): boolean {
    return subtela.manual === this.manualSelecionado;
  }

  tituloTelaAtual(): string {
    if (this.manualSelecionado === 'impressao') return 'Impressao de Venda';
    if (this.manualSelecionado === 'comissoes') return 'Relatorios de Comissoes';
    return 'Demonstrativo de Vendas';
  }

  descricaoTelaAtual(): string {
    if (this.manualSelecionado === 'impressao') {
      return 'Busca vendas por cliente, abre o orcamento em formato A4 e permite voltar, ajustar zoom, imprimir e gerar PDF.';
    }

    if (this.manualSelecionado === 'comissoes') {
      return 'Consulta e confere comissoes por periodo e filtros, apresentando totais, detalhes analiticos e apoio para exportacao ou impressao.';
    }

    return 'Consulta vendas por cliente ou vendedor, filtra por periodo, permite acoes em lote, emissao de PDF, impressao, WhatsApp, QR-Code Pix e conferencia dos totais.';
  }

  funcoesTelaAtual(): ManualFuncao[] {
    if (this.manualSelecionado === 'impressao') return this.funcoesImpressaoVenda;
    if (this.manualSelecionado === 'comissoes') return this.funcoesRelatoriosComissoes;
    return this.funcoesDemonstrativo;
  }

  fecharComoUsar(): void {
    this.modalComoUsar = null;
  }
}
